import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { Button, Input } from "@renderbus/ui";
import { useInviteRewards } from "./hooks/useInviteRewards";
import Process01 from "../../assets/images/process01.png";
import Process02 from "../../assets/images/process02.png";
import Process03 from "../../assets/images/process03.png";
import PictureProcess01 from "../../assets/images/picture-process01.png";
import PictureProcess02 from "../../assets/images/picture-process02.png";
import PictureProcess03 from "../../assets/images/picture-process03.png";
import PictureProcess04 from "../../assets/images/picture-process04.png";
import PictureProcess05 from "../../assets/images/picture-process05.png";
import Vector from "../../assets/images/vector.png";
import PictureVector from "../../assets/images/picture-vector.png";
import { InviteTable } from "./components/invite-table";
import { useGlobalStore } from "@/store/GlobalStore";
import { useState } from "react";
import { PosterModal } from "@renderbus/widgets/components/poster-modal";
import { PicturePosterModal } from "@renderbus/widgets/components/picture-poster-modal";
import {
  CardItem,
  CardVector,
  ChannelIcon,
  ChannelIconWrapper,
  InviteRecardContain,
  InviteRewardBottom,
  InviteRewardLeft,
  InviteTitle,
  ProcessCard,
  ShareChannelText,
} from "./atoms";
import { PYQ } from "../../assets/icons/invite-rewards/pyq";
import { WeiBo } from "../../assets/icons/invite-rewards/weibo";
import { XiaoHongShu } from "../../assets/icons/invite-rewards/xiaohongshu";
import { ZhiHu } from "../../assets/icons/invite-rewards/zhihu";
import { InviteSource } from "project-config/constants";

export function InviteRewards() {
  const t = getTranslateNsT("center");
  const { link, handleCopy } = useInviteRewards();
  const { isPictureUser, userInfo } = useGlobalStore();
  const [openSharePoster, setOpenSharePoster] = useState(false);
  const [openPictureSharePoster, setOpenPictureSharePoster] = useState(false);

  const ProcessList = [
    {
      image: Process01,
      text: t("picture_invite_process1"),
      num: "01",
    },
    {
      image: Process02,
      text: isPictureUser
        ? t("picture_invite_process2")
        : t("animation_invite_process2"),
      num: "02",
    },
    {
      image: Process03,
      text: t("picture_invite_process3"),
      num: "03",
    },
  ];

  const PictureProcessList = [
    {
      image: PictureProcess01,
      text: t("picture_invite_process_text1"),
      num: "01",
    },
    {
      image: PictureProcess02,
      text: t("picture_invite_process_text2"),
      num: "02",
    },
    {
      image: PictureProcess03,
      text: t("picture_invite_process_text3"),
      num: "03",
    },
    {
      image: PictureProcess04,
      text: t("picture_invite_process_text4"),
      num: "04",
    },
    {
      image: PictureProcess05,
      text: t("picture_invite_process_text5"),
      num: "05",
    },
  ];

  return (
    <InviteRecardContain>
      <ProcessCard>
        {(isPictureUser ? PictureProcessList : ProcessList).map(
          (item, index, arr) => {
            return (
              <CardItem key={index} isPictureUser={isPictureUser}>
                <div style={{ flexShrink: 0 }}>
                  <div className="num-text">{item.num}</div>
                  <img src={item.image} alt="" className="icon" />
                  <div>{item.text}</div>
                </div>
                {index !== arr.length - 1 && (
                  <CardVector isPictureUser={isPictureUser}>
                    <img
                      src={isPictureUser ? PictureVector : Vector}
                      alt=""
                      style={{
                        maxWidth: isPictureUser ? "100%" : "240px",
                      }}
                    />
                  </CardVector>
                )}
              </CardItem>
            );
          }
        )}
      </ProcessCard>
      <InviteRewardBottom>
        <InviteRewardLeft>
          <InviteTitle>{t("picture_invite_rewards")}</InviteTitle>
          <Input
            disabled
            prefix={t("picture_invite_link")}
            value={link}
            suffix={
              <>
                <Button
                  onClick={() =>
                    isPictureUser
                      ? setOpenPictureSharePoster(true)
                      : setOpenSharePoster(true)
                  }
                  className="share-poster-btn"
                >
                  {t("animation_share_poster")}
                </Button>
                <Button type="primary" onClick={handleCopy}>
                  {t("picture_invite_copy")}
                </Button>
              </>
            }
          />
          <ShareChannelText>{t("share_channel_text")}</ShareChannelText>
          <ChannelIconWrapper>
            {[<WeiBo />, <ZhiHu />, <XiaoHongShu />, <PYQ />].map(
              (item, index) => (
                <ChannelIcon key={index}>{item}</ChannelIcon>
              )
            )}
          </ChannelIconWrapper>
          <div>
            <p style={{ color: "white" }}>{t("picture_invite_rule")}</p>
            {isPictureUser ? (
              <>
                <p>{t("picture_invite_rule_text_01")}</p>
                <p>{t("picture_invite_rule_text_2")}</p>
                <p>{t("picture_invite_rule_text_03")}</p>
                <p>{t("picture_invite_rule_text_04")}</p>
                <p>{t("picture_invite_rule_text_05")}</p>
              </>
            ) : (
              <>
                <p>{t("picture_invite_rule_content_01")}</p>
                <p>{t("animation_invite_rule_content_02")}</p>
                <p>{t("animation_invite_rule_content_03")}</p>
                <p>{t("animation_invite_rule_content_04")}</p>
                <p>{t("animation_invite_rule_content_05")}</p>
                <p>{t("animation_invite_rule_content_06")}</p>
              </>
            )}
          </div>
        </InviteRewardLeft>
        <InviteTable />
      </InviteRewardBottom>
      {/* 动画海报 */}
      {openSharePoster && !!userInfo && (
        <PosterModal
          userInfo={userInfo as any}
          handleClosePoster={() => setOpenSharePoster(false)}
        />
      )}
      {/* 效果图海报 */}
      {openPictureSharePoster && !!userInfo && (
        <PicturePosterModal
          userInfo={userInfo as any}
          handleClosePoster={() => setOpenPictureSharePoster(false)}
          source={InviteSource.WebUserCenter}
        />
      )}
    </InviteRecardContain>
  );
}
